import { useEffect, useState } from "react";
import axios from 'axios';
import Main from '../../../component/Main';
import FidelityCommon from "./FidelityCommon";
import ExcelDownload from "../../../component/common/button/ExcelDownload";
import Loading from "../../../component/common/loading/Loading";
import MergedTableHeader from "../../../component/common/dataGrid/MergedTableHeader";

import { useDynamicStyle } from "../../../hooks/useDynamicStyle";
import { useSubIcon } from "../../../hooks/useSubIcon";
import '../../../css/data-grid.css';
import * as Icons from '../../../images/icons/icons_component';

const FidelityInputStatic = () => {

    const today = new Date();
    const currentYear = today.getFullYear();
    let currentMonth = today.getMonth() + 1;
    if (currentMonth < 10) {
        currentMonth = "0" + currentMonth;
    }

    const [searchParams, setSearchParams] = useState({
        searchFromdate: '',
        searchTodate: '',
        searchDateCls: '',
        searchGrdc: '',
        searchType: 'M',
        searchCheck1: currentYear,
        searchCheck2: '',
    });
    const dataHead = ['기관명', '입력대상건수', '입력건수', '연동 후 제외건수', '미입력 건수', '입력률(%)'];
    const dataColumn = ['EMOG_NAME', 'TRGET_CO', 'INPUT_CO', 'HYPTRPYUPPT_INPUT_CO', 'TRGET_UNINPUT_CO', 'NRMLT_TRNS_RT'];
    const excelFileName = `외상환자 데이터 입력현황`;
    const apiCall = '/ptmiapi/fidelityInputStaticList.do';
    const apiCntCall = '';

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });
    const popupPropsInfo = {
        checked: ['TRGET_CO', 'INPUT_CO', 'HYPTRPYUPPT_INPUT_CO', 'TRGET_UNINPUT_CO'],
        localStorageName: 'fidelityInput',
        popupAddress: "/nedis/trmsInfo/trms_fidelityCommon_popup.do",
    };

    const fetchData = async () => {
        try {
            const response = await axios.get(apiCall,
                { params: searchParams }
            );

            setState(prev => ({
                ...prev,
                dataList: response.data,
                isSearched: true
            }));
            if (apiCntCall === '') {
                setPageInfo(prev => ({
                    ...prev,
                    totalItems: response.data.length
                }));
            } else {
                fetchDataCnt();
            }
            setState(prev => ({
                ...prev,
                isLoading: false
            }));
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    };

    const fetchDataCnt = async () => {
        try {
            const response = await axios.get(apiCntCall,
                { params: searchParams }
            );
            setPageInfo(prev => ({
                ...prev,
                totalItems: response.data
            }));
        } catch (error) {
            console.error('데이터 카운터 중 오류 발생:', error);
        }
    };

    const search = () => {
        setState(prev => ({
            ...prev,
            isSearched: false,
            isLoading: true
        }));
        setPageInfo(prev => ({
            ...prev,
            currentPage: 1,
        }));
        fetchData();
    };

    const { fontColor, primaryBackColor, lightBackColor, borderColorGray, hoverLightFontColor } = useDynamicStyle();

    const { EmptyIcon, NullIcon } = useSubIcon();

    useEffect(() => {
        search();
    }, [searchParams.searchCheck2]);
    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="15%" />
                        <col width="15%" />
                        <col width="15%" />
                        <col width="15%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <FidelityCommon
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                setSearchParams={setSearchParams}
                            />
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='search_btn_wrapper'>
                <span className='total_items'>전체&nbsp;<strong className={fontColor}>{pageInfo.totalItems}</strong>건</span>
                {searchParams.searchDateCls && (
                    <span style={{ background: 'yellow' }}>*분석일자는 {searchParams.searchDateCls.slice(0, 4)}년 {searchParams.searchDateCls.slice(4, 6)}월 {searchParams.searchDateCls.slice(6, 8)}일이며, 대상기간은 {searchParams.searchFromdate.slice(0, 4)}년 {searchParams.searchFromdate.slice(4, 6)}월 {searchParams.searchFromdate.slice(6, 8)}일 ~ {searchParams.searchTodate.slice(0, 4)}년 {searchParams.searchTodate.slice(4, 6)}월 {searchParams.searchTodate.slice(6, 8)}일</span>
                )}
                <div className='btn_container'>
                    <button onClick={search} disabled={state.isLoading ? 'disabled' : ''} className={`search_btn ${primaryBackColor}`}><Icons.Search16w />검색</button>
                    {excelFileName === '' ? <div></div> :
                        <ExcelDownload
                            excelHead={dataHead}
                            excelData={state.dataList}
                            searched={state.isSearched}
                            dataCode={dataColumn}
                            excelFileName={excelFileName}
                        />
                    }
                </div>
            </div>
            <div className='data_grid_container'>
                {state.isLoading ? <Loading /> :
                    <>
                        <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                        <div className={`data_list_table ${state.isSearched ? 'grid-animation' : ''}`}>
                            <table>
                                <MergedTableHeader
                                    headers={dataHead}
                                />
                                <tbody>
                                    {state.dataList.length === 0 ? (
                                        <tr>
                                            <td colSpan={1000} style={{ padding: '0' }}>
                                                <span className={`data_empty ${lightBackColor}`}>
                                                    {state.isSearched ? EmptyIcon : NullIcon}
                                                    {state.isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                                </span>
                                            </td>
                                        </tr>
                                    ) : (
                                        state.dataList.map((item, rowIndex) => {
                                            const gridColor = rowIndex % 2 === 0 ? lightBackColor : '';
                                            return (
                                                <tr key={rowIndex} className={gridColor}>
                                                    {dataColumn.map((col, colIndex) => {
                                                        const prefix = col;
                                                        const isClickable = popupPropsInfo.checked.includes(prefix);
                                                        const handleClick = () => {
                                                            const senData = {
                                                                emtInsttCd: state.dataList[rowIndex].EMT_INSTT_CD,
                                                                emtInsttNm: encodeURIComponent(encodeURIComponent(state.dataList[rowIndex].EMOG_NAME)),
                                                                targetData: dataColumn[colIndex],
                                                            };
                                                            const totalObj = Object.assign({}, searchParams, senData);

                                                            let popup = null;

                                                            if (state.isSearched) {
                                                                localStorage.setItem(popupPropsInfo.localStorageName, JSON.stringify(totalObj));
                                                                popup = window.open(popupPropsInfo.popupAddress, "팝업", `scrollbars=1, resizable=0, width=1500, height=700, left=30 ,top=30`);
                                                            }
                                                        };

                                                        const cellStyle = isClickable ? `underline-pointer ${hoverLightFontColor}` : '';

                                                        return (
                                                            <td
                                                                key={colIndex}
                                                                onClick={isClickable ? handleClick : undefined}
                                                                className={cellStyle}
                                                            >
                                                                {item[col]}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            )
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <hr className='mr-1-1 co_border_gray' />
                    </>
                }
            </div>
            <div className='pt-3'>
                <h5>* 각 항목 설명</h5>
                <p>&ensp;- 입력대상 건수(입력 건수 + 미입력 건수 - 연동 후 제외 건수) : 외상등록체계에 전송해야 하는 건수</p>
                <p>&ensp;- 입력 건수  : 외상등록체계에 전송된 건수 (연동 후 제외 건 포함)</p>
                <p>&ensp;- 연동 후 제외 건수 : 외상등록체계에 전송하였으나, 표준등록체계 데이터의 상태 변화로 입력대상에서 제외된 건수</p>
                <p>&ensp;- 미입력 건수 : 외상등록체계에 전송되어야 하나 전송되지 않은 건수</p>
                <p>&ensp;- 입력률 = (입력 건수 - 연동 후 제외 미처리건수) / 대상건수  * 100으로 계산됩니다.</p>
            </div>
        </Main>
    )
}

export default FidelityInputStatic;